import * as StorageService from "./StorageService";
import palette from "../theme/palette";

import SuccessIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorIcon from '@mui/icons-material/ErrorOutline';
import WarningIcon from '@mui/icons-material/WarningAmber';
import * as Languages from "../constants/Languages";

export const DOCUMENTS_DETAILS = {
    ID_CARD: {
        title: 'Document de identitate (Buletin/Pașaport)',
        title_en: 'National ID/Passport',
        key: 'id_card',
        methodName: 'setIdCardUploaded',
        reUpdatable: true
    },
    DRIVE_DOC: {
        title: 'Permis de conducere',
        title_en: 'Driving license',
        key: 'drive_doc',
        methodName: 'setDriveDoc',
        reUpdatable: true
    },
    ID_CARD_BACK: {
        title: 'Spatele documentului de identitate (Buletin/Pașaport)',
        title_en: 'Back of identity document',
        key: 'id_card_back',
        methodName: 'setIdCardBackUploaded',
        reUpdatable: true,
        optional: true
    },
    PERSON_WITH_ID: {
        title: 'Dumneavoastră ținând documentul de identitate în mână',
        title_en: 'You holding your ID',
        key: 'person_with_id',
        methodName: 'setPersonWithIdCardUploaded',
        reUpdatable: true
    },
    BUSINESS_CONTRACT: {
        title: 'Împuternicire de la angajator',
        title_en: 'Power of attorney from employer',
        key: 'business_contract',
        methodName: 'setBusinessContractUploaded',
        reUpdatable: true
    },
    REGISTRATION_CERTIFICATE: {
        title: 'Certificatul de înregistrare a firmei',
        title_en: 'Certificate of company registration',
        key: 'registration_certificate',
        methodName: 'setRegistrationCertificate',
        reUpdatable: true
    },
    LAWYER_CONTRACT: {
        title: 'Contract',
        title_en: 'Contract',
        key: 'lawyer_contract',
        reUpdatable: true
    },
    POLICE_RECORD: {
        title: 'Cazier',
        title_en: 'Criminal record',
        key: 'police_record',
        reUpdatable: false
    },
    POLICE_RECORD_TRANSLATED: {
        title: 'Cazier tradus',
        title_en: 'Translated criminal record',
        key: 'police_record_translated',
        reUpdatable: false
    },
    SRL_ANEXA_38: {
        title: 'Anexa 38',
        title_en: 'Anexa 38',
        key: 'srl_anexa_38',
        reUpdatable: true
    },
    SIGNATURE_FOR_LAWYER_CONTRACT: {
        title: 'Împuternicire către avocat',
        title_en: 'Power of Attorney',
        key: 'signature_for_lawyer_contract',
        reUpdatable: false
    },
    PAYMENT_PROOF: {
        title: 'Dovada plății',
        title_en: 'Proof of Payment',
        key: 'payment_proof',
        reUpdatable: false
    },
    POWER_OF_ATTORNEY: {
        title: 'Împuternicire firmă',
        title_en: 'Company power of Attorney',
        key: 'power_of_attorney',
        reUpdatable: true
    },
    isPoliceRecord: (type) => {
        return (type === undefined || type === null) ? false : type.toLowerCase() === 'police_record'
    },
    isPoliceRecordTranslated: (type) => {
        return (type === undefined || type === null) ? false : type.toLowerCase() === 'police_record_translated'
    }
}

export const STATUSES = {
    P6_REGISTERED: {
        key: 'registered',
        title: 'Înregistrat',
        color: 'success',
        priority: 1
    },
    P3_PENDING_PAYMENT: {
        key: 'pending_payment',
        title: 'Așteptare plată',
        color: 'error',
        priority: 2
    },
    P5_ANALYZING: {
        key: 'analyzing',
        title: 'În analiză',
        color: 'warning',
        priority: 3
    },
    P1_IN_PROGRESS: {
        key: 'in_progress',
        title: 'În progress',
        color: 'info',
        priority: 4
    },
    P7_FINISHED: {
        key: 'finished',
        title: 'Finalizat',
        color: 'secondary',
        priority: 5
    },
    P2_COMPLETED: {
        key: 'completed',
        title: 'Completă',
        color: 'primary',
        priority: 6
    },
    P4_REFUNDED: {
        key: 'refunded',
        title: 'Refunded',
        color: 'error',
        priority: 5
    },
}

let messageSettled = "Ceva";
let severitySettled = "success";

let showMessage = () => {

}

let hideMessage = () => {
}

export function getAlertMessage() {
    return messageSettled;
}

export function getAlertSeverity() {
    return severitySettled;
}

export function setAlertMessageAndSeverity({message, severity}) {
    messageSettled = message;
    severitySettled = severity;
    hideMessage();
    let color = palette[severity].main

    let icons = {
        success: <SuccessIcon/>,
        error: <ErrorIcon/>,
        info: <WarningIcon/>,
    }

    showMessage(
        message, {
            duration: 3000,
            style: {
                background: color,
                color: 'white'
            },
            position: 'top-center',
            icon: icons[severity]
        });
}

export function setShowMethod(m) {
    showMessage = m;
}

export function setHideMethod(m) {
    hideMessage = m;
}

export function setOrder(id, price, transactionVerified, paymentCode,
                         necessaryDocuments, userType, details, shareable,
                         active, fiscalDone, nextState = 'PRICE') {
    let order = {
        id: id,
        price: price,
        transactionVerified: transactionVerified,
        necessaryDocuments: necessaryDocuments,
        paymentCode: paymentCode,
        userType: userType,
        details: details,
        shareable: shareable,
        active: active,
        fiscalDone: fiscalDone,
        nextState: nextState
    }

    StorageService.setOrder(order);
}

export function verifyTransactionAndReturn() {
    let order = getOrder();
    order.transactionVerified = true;
    order.nextState = "DOCUMENTS";
    StorageService.setOrder(order);
    return order;
}

export function updateOrderState(nextState) {
    let order = getOrder();
    order.nextState = nextState;
    StorageService.setOrder(order);
    return order;
}

export function verifyFiscalInfoAndReturn() {
    let order = getOrder();
    order.fiscalDone = true;
    order.nextState = 'PAYMENT_METHOD';
    StorageService.setOrder(order);
    return order;
}

export function undefineMyOrder() {
    StorageService.setOrder(null);
}

export function resetSession() {

    StorageService.setCreatedOrder(null);
    StorageService.setUploadedDocuments(null);
    StorageService.setPaymentMethod(null);
    StorageService.setOrder(null);
}

export function resetSessionWithoutOrder() {
    StorageService.setCreatedOrder(null);
    StorageService.setUploadedDocuments(null);
    StorageService.setPaymentMethod(null);
}

export function getOrder() {
    return StorageService.getOrder();
}

export function getUploadedDocuments() {
    let docs = StorageService.getUploadedDocuments();
    return docs === undefined || docs === null ? [] : docs;
}

export function addUploadedDocuments(doc) {
    let docs = getUploadedDocuments();
    if (docs !== undefined && docs !== null && docs.findIndex(d => d.key === doc.key) >= 0) {
        return;
    }
    docs.push(doc);
    StorageService.setUploadedDocuments(docs);
}

export function getPaymentMethod() {
    return StorageService.getPaymentMethod();
}

export function setPaymentMethod(paymentMethod) {
    return StorageService.setPaymentMethod(paymentMethod);
}

export function getBrowserData() {
    let data = StorageService.getBrowserData();
    return data === undefined || data === null ? null : data;
}

export function setBrowserData(doc) {
    StorageService.setBrowserData(doc);
}

export function getFeatureSwitches() {
    let data = StorageService.getFeatureSwitches();
    return data === undefined || data === null ? null : data;
}

export function getCompanyInUse() {
    let data = StorageService.getCompanyInUse();
    return data === undefined || data === null ? null : data;
}

export function getFeatureSwitch(key) {
    let data = StorageService.getFeatureSwitches();
    if (data === undefined || data === null) {
        return null;
    }
    return data.find(d => d.type == key.toUpperCase());
}

export function getFeatureSwitchCallback(key, callback) {
    let myInterval = setInterval(() => {
        let data = StorageService.getFeatureSwitches();
        if (data === undefined || data === null) {
            return;
        }
        clearInterval(myInterval);
        return callback(data.find(d => d.type == key.toUpperCase()));
    }, 500);
}

export function setCompanyInUse(doc) {
    StorageService.setCompanyInUse(doc);
}

export function setFeatureSwitches(doc) {
    StorageService.setFeatureSwitches(doc);
}

export function setPublicPrices(doc) {
    StorageService.setPublicPrices(doc);
}

export function getPublicPrices() {
    let data = StorageService.getPublicPrices();
    if (data === undefined || data === null) {
        return [];
    }
    return data;
}

let defaultPriceMap = {
    'DELIVERY_ELECTRONIC': 0,
    'REGIME_STANDARD': 0,
    'DELIVERY_IN_COUNTRY': 0,
    'APOSTILA': 200,
    'REGIME_FOREIGN_UE': 0,
    'LEGALIZED': 150,
    'REGIME_URGENT': 100,
    'BASIC_DOCUMENT': 250,
    'DELIVERY_OUT_OF_COUNTRY': 150,
    'BASIC_DOCUMENT_OUT_OF_COUNTRY': 450,
    'CERT_LEGALIZED': 100,
    'CERT_APOSTILA': 200,
    'CERT_EXPERT_VERIFICATION': 49,
    'CERT_DELIVERY_ELECTRONIC': 0,
    'CERT_REGIME_STANDARD': 179,
    'CERT_REGIME_URGENT': 219,
    'CERT_REGIME_STANDARD_OC': 339,
    'CERT_REGIME_URGENT_OC': 389
}

let defaultCountryPrices = [
    {
        "id": 25,
        "price": 100,
        "price_of": "ROMANA",
        "price_of_en": "ROMANIAN",
        "urgent_price": 100,
        "code": "ro"
    },
    {
        "id": 3,
        "price": 150,
        "price_of": "BULGARA",
        "price_of_en": "BULGARIAN",
        "urgent_price": 200,
        "code": "bg"
    },
    {
        "id": 4,
        "price": 150,
        "price_of": "CEHA",
        "price_of_en": "CZECH",
        "urgent_price": 200,
        "code": "cz"
    },
    {
        "id": 5,
        "price": 300,
        "price_of": "CHINEZA",
        "price_of_en": "CHINESE",
        "urgent_price": 400,
        "code": "cn"
    },
    {
        "id": 6,
        "price": 300,
        "price_of": "COREEANA",
        "price_of_en": "KOREAN",
        "urgent_price": 400,
        "code": "kp"
    },
    {
        "id": 7,
        "price": 300,
        "price_of": "CROATA",
        "price_of_en": "CROATIA",
        "urgent_price": 400,
        "code": "hr"
    },
    {
        "id": 8,
        "price": 300,
        "price_of": "DANEZA",
        "price_of_en": "DANISH",
        "urgent_price": 400,
        "code": "dk"
    },
    {
        "id": 10,
        "price": 150,
        "price_of": "ENGLEZA",
        "price_of_en": "ENGLISH",
        "urgent_price": 200,
        "code": "en"
    },
    {
        "id": 11,
        "price": 300,
        "price_of": "FINLANDEZA",
        "price_of_en": "FINNISH",
        "urgent_price": 400,
        "code": "fi"
    },
    {
        "id": 13,
        "price": 150,
        "price_of": "GERMANA",
        "price_of_en": "GERMAN",
        "urgent_price": 200,
        "code": "de"
    },
    {
        "id": 14,
        "price": 150,
        "price_of": "GREACA",
        "price_of_en": "GREEK",
        "urgent_price": 200,
        "code": "gr"
    },
    {
        "id": 15,
        "price": 150,
        "price_of": "ITALIANA",
        "price_of_en": "ITALIAN",
        "urgent_price": 200,
        "code": "it"
    },
    {
        "id": 16,
        "price": 300,
        "price_of": "JAPONEZA",
        "price_of_en": "JAPANESE",
        "urgent_price": 400,
        "code": "jp"
    },
    {
        "id": 17,
        "price": 400,
        "price_of": "LITUANIANA",
        "price_of_en": "LITHUANIAN",
        "urgent_price": 500,
        "code": "lt"
    },
    {
        "id": 18,
        "price": 400,
        "price_of": "MACEDONEANA",
        "price_of_en": "MACEDONIAN",
        "urgent_price": 500,
        "code": "mk"
    },
    {
        "id": 20,
        "price": 250,
        "price_of": "NORVEGIANA",
        "price_of_en": "NORWAY",
        "urgent_price": 350,
        "code": "no"
    },
    {
        "id": 21,
        "price": 150,
        "price_of": "OLANDEZA",
        "price_of_en": "DUTCH",
        "urgent_price": 200,
        "code": "nl"
    },
    {
        "id": 22,
        "price": 150,
        "price_of": "POLONEZA",
        "price_of_en": "POLISH",
        "urgent_price": 200,
        "code": "pl"
    },
    {
        "id": 23,
        "price": 150,
        "price_of": "PORTUGHEZA",
        "price_of_en": "PORTUGUESE",
        "urgent_price": 200,
        "code": "pt"
    },
    {
        "id": 24,
        "price": 200,
        "price_of": "RUSA",
        "price_of_en": "RUSSIAN",
        "urgent_price": 300,
        "code": "ru"
    },
    {
        "id": 26,
        "price": 300,
        "price_of": "SARBA",
        "price_of_en": "SERBIA",
        "urgent_price": 400,
        "code": "sr"
    },
    {
        "id": 27,
        "price": 300,
        "price_of": "SLOVACA",
        "price_of_en": "SLOVAKIA",
        "urgent_price": 400,
        "code": "sk"
    },
    {
        "id": 28,
        "price": 300,
        "price_of": "SLOVENA",
        "price_of_en": "SLOVENIA",
        "urgent_price": 400,
        "code": "sl"
    },
    {
        "id": 29,
        "price": 150,
        "price_of": "SPANIOLA",
        "price_of_en": "SPANISH",
        "urgent_price": 200,
        "code": "es"
    },
    {
        "id": 30,
        "price": 200,
        "price_of": "TURCA",
        "price_of_en": "TURKISH",
        "urgent_price": 300,
        "code": "tr"
    },
    {
        "id": 31,
        "price": 300,
        "price_of": "UCRAINEANA",
        "price_of_en": "UKRAINIAN",
        "urgent_price": 400,
        "code": "ua"
    },
    {
        "id": 1,
        "price": 300,
        "price_of": "ALBANEZA",
        "price_of_en": "ALBANIAN",
        "urgent_price": 400,
        "code": "al"
    },
    {
        "id": 2,
        "price": 300,
        "price_of": "ARABA",
        "price_of_en": "ARABIC",
        "urgent_price": 400,
        "code": "ar"
    },
    {
        "id": 19,
        "price": 150,
        "price_of": "MAGHIARA",
        "price_of_en": "HUNGARY",
        "urgent_price": 200,
        "code": "hu"
    },
    {
        "id": 9,
        "price": 300,
        "price_of": "EBRAICA",
        "price_of_en": "HEBREW",
        "urgent_price": 400,
        "code": "il"
    },
    {
        "id": 12,
        "price": 150,
        "price_of": "FRANCEZA",
        "price_of_en": "FRENCH",
        "urgent_price": 200,
        "code": "fr"
    }
]

export function getPublicPrice(key) {
    let find = getPublicPriceFUll(key);
    if (!find) {
        return defaultPriceMap[key];
    }
    return find.price;
}

function findByPriceOf(key) {
    return d => {
        let thePrice = d.priceOf == key.toUpperCase()
            || d.price_of == key.toUpperCase() || d.price_of_en == key.toUpperCase();
        return thePrice;
    };
}

export function getPublicPriceFUll(key) {
    let data = StorageService.getPublicPrices();
    if (data === undefined || data === null) {
        return null;
    }
    let find = data.find(findByPriceOf(key));
    if (!find) {
        find = defaultCountryPrices.find(findByPriceOf(key))
    }
    return find;
}

export function getPublicPriceFUllByKey(key) {
    let data = StorageService.getPublicPrices();
    if (data === undefined || data === null) {
        return null;
    }
    let find = data.find(dc => dc.priceOf == key);
    if (find) {
        return find;
    }

    let langKey = Languages.getLangKeyByLabel(key);
    let enLang = Languages.getLanguageByKey(langKey)

    find = data.find(dc => dc.priceOf == enLang.label);
    return find;
}

export function getCreatedOrder() {
    let data = StorageService.getCreatedOrder();
    if (data === undefined || data === null) {
        return null;
    }
    let currentDate = new Date();
    let differenceBetweenDatesInMinutes = Math.ceil(Math.abs(currentDate - new Date(data.retrievedAt)) / (1000 * 60));
    if (differenceBetweenDatesInMinutes > 15) {
        setCreatedOrder(null);
        return null;
    }
    return data;
}

export function setCreatedOrder(order) {
    if (order === undefined || order === null) {
        return StorageService.setCreatedOrder(null);
    }
    let orderPacked = {
        ...order,
        retrievedAt: new Date()
    }
    StorageService.setCreatedOrder(orderPacked);
}

export function getAcceptedCookieValue() {
    let obj = StorageService.getCookiesAcceptedValue();
    if (obj === undefined || obj === null) {
        return false;
    }
    return obj.value;
}

export function setAcceptedCookieValue(value) {
    StorageService.setCookiesAcceptedValue({value: value});
}


